import { svg } from "lit";
const icon = svg `<path d="M12.5831 10.1766L14.4068 12.0003V13.0836H10.5414V17.4169L9.99977 17.9586L9.45813 17.4169V13.0836H5.59277V12.0003L7.41646 10.1766V4.50031H6.41646V3.41699H13.5831V4.50031H12.5831V10.1766ZM7.12477 12.0003H12.8748L11.4998 10.6253V4.50031H8.49977V10.6253L7.12477 12.0003Z" fill="currentColor"/>`;
export default icon;
